module.exports = __webpack_public_path__ + "static/img/qrcode.f7027857.png";